import { DateFunctions } from "../static/date-functions";
import { CommonValues } from "../static/CommonValues";

export class MasterJobList 
{
    constructor(data: MasterJobList = null) {
        if (data != null) {
            this.value = data.value;
            this.category = data.category;
            this.relatedJobType = data.relatedJobType;
            this.description = data.description;
            this.dispatchStatusName = data.dispatchStatusName;
            this.isMainJob = data.isMainJob;
            this.relatedJobTypeId = data.relatedJobTypeId;
            this.mainJobTypeId = data.mainJobTypeId;
            this.date = DateFunctions.getDate(data.date);
        }

    }
 value: any ;
 category: string;
 relatedJobType: string;
 description: string;
 dispatchStatusName: string;
 isMainJob: boolean;
 relatedJobTypeId: any;
 mainJobTypeId: any;
    date: Date;
    get display(): string {
        return this.description + " - " + this.dispatchStatusName; // + (this.relatedJobTypeId === CommonValues.RelatedJobType_ChangeOrder ? " - Change Order": "");
    }
}